export default __webpack_public_path__ + "static/media/August2010.8061de22.png";